import { useAxios } from '@/hooks/useAxios';
import { getQueryKey } from '@/hooks/useQueryKeys';
import { useAuth } from '@/state/auth';
import { UseExtendQueryOptions, useQuery } from '@/utils/api';

interface Alert {
  priority: string;
  name: string;
  count: number;
  source: string;
  value: string;
  sort?: string[];
  key: string;
}

export function useGetAccountAlerts(options?: UseExtendQueryOptions<Alert[]>) {
  const { friend, me } = useAuth();
  const axios = useAxios();

  return useQuery<Alert[]>({
    ...options,
    defaultErrorMessage: 'Failed to fetch account alerts',
    queryKey: getQueryKey.getAccountAlerts(friend || me),
    queryFn: async () => {
      const res = await axios.get(`/account/alert`);
      return res.data;
    },
  });
}
